<script lang="ts">
	export let title: string;
	export let description: string;

</script>

<div class="achievement-body" data-testid="achievement-body">
	<slot />
	<div class="oc-headline-50">{title}</div>
	<div class="oc-copy-75">{description}</div>
</div>